export enum Steps {
  "DOB_AUTH" = "dob_auth",
  "ORDER_OVERVIEW" = "order_overview",
}

export enum OrderPayMoreSteps {
  "DOB_AUTH" = "dob_auth",
  "PAY_MORE" = "pay_more",
}

export const DEFAULT_EXPIRATION_DAYS = 2;
